export default "__VITE_ASSET__892a8165__"